import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import Home from "../pages/Home";

import DriverDetails from "../components/driver/DriverDetails";
import DetailsDriverCompany from "../components/driverCompany/DriverCompanyDetails";
import Setting from "../components/setting/Settings";
import SocialMedia from "../components/socialMedia/SocialMedia";
import CarPrice from "../components/carPrice/CarPrice";
import CityPrice from "../components/cityPrice/CityPrice";
import CalculatorArea from "../components/calculatorArea/CalculatorArea";
import Customer from "../components/customers/Customers";
import CustomerDetails from "../components/customers/CustomerDetails";
import Drivers from "../components/driver/Drivers";
import ApprovedDrivers from "../components/driver/ApprovedDrivers";
import PendingDrivers from "../components/driver/PendingDrivers";
import Invoice from "../components/invoice/Invoice";
import InvoiceForm from "../components/invoice/InvoiceForm";

import SelectCustomer from "../components/clientChat/SelectCustomer";
import ChatClient from "../components/clientChat/ChatClient";
import ClientList from '../components/clientChat/ClientList';
import ChatDriver from "../components/driverChat/ChatDriver";
import DriverList from '../components/driverChat/DriverList';
import SelectDriver from "../components/driverChat/SelectDriver";
import ChatDriverCompany from "../components/driverCompanyChat/ChatDriverCompany";
import DriverCompanyList from '../components/driverCompanyChat/DriverCompanyList';
import SelectDriverCompany from "../components/driverCompanyChat/SelectDriverCompany";

import SpecialBooking from "../components/specialBooking/SpecialBooking";
import SpecialBookingForm from "../components/specialBooking/SpecialBookingCreate";
import SpecialBookingDetails from "../components/specialBooking/SpecialBookingDetails";
import SpecialBookingTrack from "../components/specialBooking/SpecialBookingTrack";

import Booking from "../components/bookings/Booking";
import BookingDetails from "../components/bookings/BookingDetails";
import BookingTrack from "../components/bookings/BookingTrack";
import BookingLiveTrack from "../components/bookings/BookingLiveTrack";

import BookingOrders from "../components/bookingOrders/BookingOrder";
import BookingOrderDetails from "../components/bookingOrders/BookingOrderDetails";
import OrdersForBooking from "../components/bookingOrders/OrdersForBooking";

import TransportOrders from "../components/transportOrders/TransportOrder";
import TransportOrderDetails from "../components/transportOrders/TransportOrderDetails";

import Transport from "../components/transports/Transport";
import TransportDetails from "../components/transports/TransportDetails";
import TransportTrack from "../components/transports/TransportTrack";
import TransportLiveTrack from "../components/transports/TransportLiveTrack";
import OrdersForTransport from "../components/transports/OrdersForTransport";
// import TransportOrderDetails from "../components/transportOrders/TransportOrderDetails";

import DriverCompany from "../components/driverCompany/DriverCompany";
import DriverCompanyForm from "../components/driverCompany/DriverCompanyForm";
import DriverCompanyDetails from "../components/driverCompany/DriverCompanyDetails";
import AdminCompany from "../components/adminCompany/AdminCompany";
import Logs from "../components/logs/Logs";
import Contact from "../components/contactMessage/Contact";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import Profile from "../pages/Profile";
import ProtectedRoute from "../components/ProtectedRoute";
import AdminMapView from "../components/adminMapView/AdminMapView";
import Commissions from "../components/commissions/Commissions";
import BookingInvoices from "../components/bookingInvoices/BookingInvoices";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin/forgot-password" element={<ForgotPassword />} />
      <Route path="/admin/reset-password/:email/:token" element={<ResetPassword />} />

      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="profile" element={<Profile />} />
        <Route path="settings" element={<Setting />} />
        <Route path="social-media" element={<SocialMedia />} />
        <Route path="car-prices" element={<CarPrice />} />
        <Route path="commissions" element={<Commissions />} />
        <Route path="city-prices" element={<CityPrice />} />
        <Route path="calculator-areas" element={<CalculatorArea />} />

        <Route path="admin-company" element={<AdminCompany />} />
        <Route path="customers" element={<Customer />} />
        <Route path="customers/details/:id" element={<CustomerDetails />} />
        <Route path="drivers-company" element={<DriverCompany />} />
        <Route path="drivers-company/new" element={<DriverCompanyForm />} />
        <Route path="drivers-company/edit/:id" element={<DriverCompanyForm />} />
        <Route path="drivers-company/details/:id" element={<DriverCompanyDetails />} />
        <Route path="drivers" element={<Drivers />} />
        <Route path="drivers/drivers-approved" element={<ApprovedDrivers />} />
        <Route path="drivers/drivers-pending" element={<PendingDrivers />} />
        <Route path="drivers/details/:id" element={<DriverDetails />} />
        
        <Route path="special-bookings" element={<SpecialBooking />} />
        <Route path="special-bookings/new" element={<SpecialBookingForm />} />
        <Route path="special-bookings/details/:id" element={<SpecialBookingDetails />} />
        <Route path="special-bookings/track/:booking_id" element={<SpecialBookingTrack />} />
        <Route path="bookings" element={<Booking />} />
        <Route path="bookings/details/:id" element={<BookingDetails />} />
        <Route path="bookings/track/:booking_id" element={<BookingTrack />} />
        <Route path="bookings/live-tracking/:id" element={<BookingLiveTrack />} />

        <Route path="booking-invoices" element={<BookingInvoices />} />

        <Route path="transports" element={<Transport />} />
        <Route path="transports/details/:id" element={<TransportDetails />} />
        <Route path="transports/track/:booking_id" element={<TransportTrack />} />
        <Route path="transports/live-tracking/:id" element={<TransportLiveTrack />} />
        <Route path="transports/orders-for-transport/:id" element={<OrdersForTransport />} />
        {/* <Route path="transports/transport-orders/details/:id" element={<TransportOrderDetails />} /> */}

        <Route path="transport-orders" element={<TransportOrders />} />
        <Route path="transport-orders/details/:id" element={<TransportOrderDetails />} />

        <Route path="admin-map" element={<AdminMapView />} />

        <Route path="invoices" element={<Invoice />} />
        <Route path="invoices/new" element={<InvoiceForm />} />
        <Route path="invoices/edit/:id" element={<InvoiceForm />} />
        {/* <Route path="bookings" element={<Driver />} /> */}
        <Route path="map" element={<DriverDetails />} />

        <Route path="booking-orders" element={<BookingOrders />} />
        <Route path="booking-orders/details/:id" element={<BookingOrderDetails />} />
        <Route path="booking-orders/orders-for-booking/:id" element={<OrdersForBooking />} />
        {/* <Route path="accepted-orders" element={<Driver />} />
        <Route path="in-delivery" element={<Driver />} />
        <Route path="completed-orders" element={<Driver />} /> */}
        <Route path="driver-company/:id" element={<DetailsDriverCompany />} />

        <Route path="client-list" element={<ClientList />} />
        <Route path="client-list/chat-client/:id" element={<ChatClient />} />
        <Route path="/admin/client-list/select-customer" element={<SelectCustomer />} />
        <Route path="driver-list" element={<DriverList />} />
        <Route path="driver-list/chat-driver/:id" element={<ChatDriver />} />
        <Route path="/admin/driver-list/select-driver" element={<SelectDriver />} />
        <Route path="driver-company-list" element={<DriverCompanyList />} />
        <Route path="driver-company-list/chat-driver-company/:id" element={<ChatDriverCompany />} />
        <Route path="/admin/driver-company-list/select-driver-company" element={<SelectDriverCompany />} />
        
        <Route path="logs" element={<Logs />} />
        <Route path="contact" element={<Contact />} />
      </Route>
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}